module.exports = __webpack_public_path__ + "img/slide14.5feba052.png";